'use client';

var SEARCH_PARAMS = {
    QUERY: 'q',
    LOCATION: 'l',
    DISTRICT: 'd',
    CATEGORY: 'f',
    INDUSTRY: 'i',
    WORKING_TYPE: 'w',
    JOB_LEVEL: 'level',
    URGENT: 'urgent',
    PAGE: 'page'
};

export { SEARCH_PARAMS };
//# sourceMappingURL=types.js.map
